import { format } from "date-fns";
import i18next from "i18next";
import { capitalize } from "lodash";

export const pickupTimeShort = (startAt: string) => {
  const date = new Date(startAt);
  const day = format(date, "eeeeee PP")
    .replace(/,\s\d{4}/, "") // Remove ', year'
    .replace(/\s\d{4}/, "") // Remove ' year'
    .replace(".", "");
  const time = `${i18next.t("ui.from")} ${format(date, "p")}`;
  return capitalize(`${day} - ${time}`);
};
